import React from 'react'
import healthcare1 from '../images/gocardlesss1.png';
import healthcare2 from '../images/gocardlesss2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function GoCardless() {
    return (
        <>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">
                        <span className="highlight-orange">GoCardless</span> – Fintech Management Software Tailored for GoCardless
                    </div>
                </div>
            </section>

            <section className="container my-5">
                {/* Section 1: Project Overview */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="Fintech Platform Overview"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">GoCardless</span> – Fintech Management Software
                        </h1>

                        <p className="mb-3 ps-1">
                            GoCardless is a fully customised fintech management platform designed to automate payment collection,
                            enhance financial workflows, and streamline digital transaction operations. The system centralizes payment
                            processing, customer billing, subscription handling, payout tracking, and revenue analytics into a unified
                            dashboard — enabling financial teams to operate with precision and real-time insights.
                        </p>

                        <p className="mb-3 ps-1">
                            The platform supports automated recurring payments, dispute management, multi-currency transactions,
                            bank-to-bank transfers, and regulatory compliance workflows. With end-to-end automation, GoCardless enables
                            financial operations to scale faster, eliminate manual interventions, and ensure high-accuracy transaction processing.
                        </p>

                        <p className="mb-3 ps-1 fw-bold">
                            <span className="highlight-orange">Business Impact:</span> Companies using this custom fintech solution
                            experienced <span className="highlight-orange">30–50% faster payment cycles</span>, reduced operational
                            overhead by <span className="highlight-orange">up to 45%</span>, and achieved
                            <span className="highlight-orange"> 2.5× ROI within the first 4–6 months</span> through automation,
                            reduced failed payments, and improved financial visibility.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Section 2: Summary & Team Info */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Client:</span> GoCardless
                        </h1>

                        <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
                        <p className="mb-3 ps-3">United Kingdom</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Technology & Purpose</h4>
                        <p className="mb-3 ps-3">
                            Payment Automation Engine, Financial Workflow Management, Multi-Currency Payment System, React, Node.js,
                            Firebase, REST APIs, Banking Integrations, Fraud Detection Module, Real-Time Financial Analytics Dashboard
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Domain</h4>
                        <p className="mb-3 ps-3">Fintech • Digital Payments • Subscription Billing</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Team Involvement</h4>
                        <p className="mb-3 ps-3">
                            UI/UX Designer, 2 Frontend Engineers, Backend Developer, Fintech Specialist,
                            Security Engineer, Automation Engineer, QA Engineer
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Duration</h4>
                        <p className="mb-4 ps-3">4 Months</p>

                        <p className="mb-4 ps-3">
                            The GoCardless Fintech Management Software was developed to automate recurring payments, empower billing teams,
                            ensure compliance, and reduce financial processing errors. The platform centralizes subscriptions, invoicing,
                            payout scheduling, bank-to-bank transfers, and customer financial profiles into a seamless ecosystem.
                            <br /><br />
                            With integrated fraud detection, smart reconciliation, automated financial workflows, and real-time analytics,
                            the system helps fintech teams reduce operational workload, increase payment success rates, and maintain
                            transparent financial governance. Designed with enterprise-grade security and scalability, the platform
                            supports high-volume transactions with accuracy and reliability.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="Fintech UI"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Section 3: Process & Key Features */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="Fintech Features"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Process</span>
                        </h1>

                        <p className="mb-3 ps-1">
                            We designed the GoCardless platform with a fintech-first architecture focused on real-time processing,
                            regulatory compliance, automation, and accuracy. The backend integrates payment gateways, bank APIs,
                            subscription engines, billing workflows, and secure data encryption — ensuring smooth, fail-safe
                            financial operations across all modules.
                        </p>

                        <p className="mb-3 ps-1">
                            The UI/UX was crafted to make financial operations simple, transparent, and task-oriented. A clean,
                            role-based interface enables finance teams, compliance officers, and administrators to manage payments,
                            resolve disputes, track payouts, and analyze revenue trends — with zero technical dependency.
                        </p>

                        <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
                        <ul className="ps-3 mb-4">
                            <li className="mb-1">Automated recurring payments & subscription billing</li>
                            <li className="mb-1">Smart reconciliation & real-time payout tracking</li>
                            <li className="mb-1">Bank-to-bank transfer engine with multi-currency support</li>
                            <li className="mb-1">Dispute management & chargeback workflow automation</li>
                            <li className="mb-1">Compliance & fraud-detection system with alerts</li>
                            <li className="mb-1">Financial analytics dashboard with revenue, churn & transaction insights</li>
                            <li className="mb-1">Centralised customer financial profiles & automated invoicing</li>
                        </ul>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Get Started
                        </a>
                    </div>
                </div>

                <OurPartner />
            </section>


        </>
    )
}

export default GoCardless